<style>
#projectTable tr th, #projectTable tr td {
  padding: .5rem;
}
</style>

<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">


        <div class="widget-heading pb-0 d-block">
          <div class="row">
            <div class="col-md-12 col-lg-10 d-flex align-items-center justify-content-between flex-wrap">
              <div>
                <h4 class="d-inline-block h4 me-4" style="line-height: 1.4">
                  Zgłoszenie: <b>{{ service.number }}</b>
                </h4>
                <span class="text-danger font-weight-bolder" v-if="service.archived">ZARCHIWIZOWANE</span>
              </div>
              <div class="ms-4">
                <Link :href="route('service.index')" class="btn btn-outline-primary">
                  <i class="bi bi-list"></i>&nbsp;Lista zgłoszeń
                </Link>
              </div>
            </div>

            <div class="col-md-12 col-lg-2 text-end">
              <form id="deleteServiceForm" class="d-inline-block me-2" method="post" @submit.prevent="deleteService">
                <input type="hidden" name="_token" :value="csrfToken">
                <button v-if="hasPermission('canDelService')" class="btn btn-outline-danger">Usuń zgłoszenie</button>
              </form>
            </div>
          </div>
          <div class="row">
            <div v-if="hasPermission('canEditService')" class="col-6 my-2">
              <form @submit.prevent="submitHideOnList" class="mt-3">
                <div class="checkbox-success custom-control custom-checkbox d-inline-block">
                  <input id="serviceHideOnList" type="checkbox" class="custom-control-input"
                         :checked="service.hide_on_list" @change="changeServiceHideOnList">
                  <label for="serviceHideOnList" class="custom-control-label h6">Nie pokazuj na liście zgłoszeń</label>
                </div>
                <button v-if="hideOnListServiceHasChanged" type="submit" class="btn btn-primary btn-sm ms-2">Zapisz
                </button>
              </form>
            </div>
            <div v-if="hasPermission('canEditService')" class="col-6 my-2">
              <form @submit.prevent="submitArchived" class="mt-3">
                <div class="checkbox-success custom-control custom-checkbox d-inline-block">
                  <input id="servicearchived" type="checkbox" class="custom-control-input"
                         :checked="service.archived" @change="changeServiceArchived">
                  <label for="servicearchived" class="custom-control-label h6">Archiwizuj zgłoszenie</label>
                </div>
                <button v-if="archivedHasChanged" type="submit" class="btn btn-primary btn-sm ms-2">Zapisz
                </button>
              </form>
            </div>
          </div>


          <serviceMenu :service="service"></serviceMenu>
        </div>

        <div class="widget-content">
          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.errors">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="row">
                <div class="col-md-12 col-lg-12 mb-3">
                  <label class="form-label" for="name">Nazwa kontrahenta:</label>
                  <input type="text" id="name" class="form-control form-control-sm text-dark fw-semibold"
                         v-model="customer.name" readonly/>
                </div>
                <div class="col-md-3 col-lg-3 mb-3">
                  <label class="form-label" for="pnumber">Numer projektu:</label>
                  <input type="text" id="pnumber" class="form-control form-control-sm text-dark fw-semibold"
                         v-model="project.number" readonly/>
                </div>
                <div class="col-md-9 col-lg-9 mb-3">
                  <label class="form-label" for="pname">Nazwa projektu:</label>
                  <input type="text" id="pname" class="form-control form-control-sm text-dark fw-semibold"
                         v-model="project.name" readonly/>
                </div>
                <form @submit.prevent="submitForm">

                  <div class="row">
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="warranty_length">Długość gwarancji:</label>
                      <input type="text" id="warranty_length" class="form-control form-control-sm"
                             :value="computedWarrantyLength"
                             @input="updateWarrantyLength($event)"/>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="warranty_end">Koniec gwarancji:</label>
                      <input type="date" id="warranty_end" class="form-control form-control-sm"
                             :value="formatDate(computedWarrantyEndDate)" @input="updateWarantyEndDate($event)"/>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label">Status gwarancji:</label>
                      <div class="btn btn-sm w-100" :class="warrantyStatusClass" disabled>
                        {{ warrantyStatusText }}
                      </div>
                    </div>
                  </div>

                  <h4 class="me-3 t-3 my-0 mb-0">Adres instalacji</h4>
                  <div class="row">

                    <!-- Adres instalacji -->
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="delivery_zip_code">Kod pocztowy:</label>
                      <input type="text" id="delivery_zip_code" class="form-control form-control-sm"
                             v-model="adres.delivery_zip_code"/>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="delivery_city">Miasto:</label>
                      <input type="text" id="delivery_city" class="form-control form-control-sm"
                             v-model="adres.delivery_city"/>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="delivery_street">Ulica:</label>
                      <input type="text" id="delivery_street" class="form-control form-control-sm"
                             v-model="adres.delivery_street"/>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="delivery_apartment">Lokal:</label>
                      <input type="text" id="delivery_apartment" class="form-control form-control-sm"
                             v-model="adres.delivery_apartment"/>
                    </div>
                  </div>
                  <h4 class="me-3 my-0 mb-0">Osoba zgłaszająca</h4>
                  <div class="row">
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="ticket_person">Imię i Nazwisko:</label>
                      <input type="text" id="ticket_person" class="form-control form-control-sm"
                             v-model="service.ticket_person"/>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="ticket_phone">Telefon:</label>
                      <input type="text" id="ticket_phone" class="form-control form-control-sm"
                             v-model="service.ticket_phone"/>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="ticket_email">E-mail:</label>
                      <input type="text" id="ticket_email" class="form-control form-control-sm"
                             v-model="service.ticket_email"/>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="created_at">Data zgłoszenia:</label>
                      <input type="date" id="created_at" class="form-control form-control-sm"
                             :value="formatDate(service.created_at)" @input="updateDate($event)"/>

                    </div>

                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="serviceCategories">Kategorie serwisu:</label>
                      <Vueform>
                        <TagsElement
                            name="serviceCategories"
                            :native="false"
                            value-prop="id"
                            label-prop="name"
                            :items="categories"
                            :default="form.service_category_ids"
                            @change="changeServiceCategories"
                        />
                      </Vueform>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="status">Status zgłoszenia:</label>
                      <select class="form-select form-select-sm" id="status" v-model="form.status">
                        <option value="NOWE">NOWE</option>
                        <option value="ZREALIZOWANE">ZREALIZOWANE</option>
                        <option value="ROZLICZONE">ROZLICZONE</option>
                      </select>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-3">
                      <label class="form-label" for="ended_at">Data zakończenia:</label>
                      <input type="date" id="ended_at" class="form-control form-control-sm"
                             :value="formatDate(service.ended_at)" @input="updateEndDate($event)"/>

                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 col-lg-12 mb-6">
                      <label class="form-label" for="description">Treść zgłoszenia:</label>
                      <textarea class="form-control form-control-sm" id="description" v-model="service.description"
                                rows="4"></textarea><br>
                    </div>
                  </div>
                  <template v-if="!isLoading">

                    <button type="submit" class="float-end btn btn-primary" :disabled="isLoading"
                            v-if="hasPermission('canEditService')" @click="submitForm">
                      {{ isLoading ? 'Wysyłanie...' : 'Zaktualizuj' }}
                    </button>
                  </template>

                  <template v-if="isLoading">
                    <div class="mt-4 spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">
                      Ładowanie...
                    </div>
                  </template>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {defineProps, ref} from "vue";
import {useForm, router} from "@inertiajs/vue3";
import serviceMenu from "@/Pages/Service/serviceMenu.vue";

import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";

import {Tooltip} from 'bootstrap';
import {isDisabled} from "bootstrap/js/src/util/index.js";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";


const {hasPermission} = usePermission();

export default {
  components: {AppLayout, serviceMenu},


  props: {
    service: {
      type: Object,
      required: true,
      default: () => ({})
    },
    adres: {
      type: Object,
      required: true,
      default: () => ({})
    },
    customer: {
      type: Object,
      required: true,
      default: () => ({})
    },
    project: {
      type: Object,
      required: true,
      default: () => ({})
    },
    userinfo: {
      type: Object,
      required: true,
      default: () => ({})
    },
    serviceCategories: {
      type: Array,
      required: true,
      default: () => [],
    },
    categories: {
      type: Array,
      required: true,
      default: () => [],
    },
    warranty: {
      type: Array,
      required: true,
      default: () => [],
    },
    warranty_save: {
      type: Array,
      required: true,
      default: () => [],
    },
  }
  ,
  data() {
    return {
      isDropdownOpen: false,
      hideOnListForm: useForm({
        hide_on_list: this.service.hide_on_list || false
      }),
      hideOnListServiceHasChanged: false,
      archiveOnListForm: useForm({
        archived: this.service.archived || false
      }),
      archivedHasChanged: false,
      isLoading: false,
      hasPermission,
      categories: this.$page.props.categories,
      selectedCategories: this.$page.props.selectedCategories,
      form: {
        status: this.service.status || "NOWE",
        service_category_ids: this.$page.props.selectedCategories,
        description: null,
        delivery_street: null,
        delivery_zip_code: null,
        delivery_city: null,
        delivery_apartment: null,
        ticket_person: null,
        ticket_phone: null,
        ticket_email: null,
        created_at: null,
        ended_at: null,
        warranty_length: null,
        warranty_end: null,
        description: null,
        attachments: [],
        errors: {}
      },

    };
  },

  watch: {
    service: {
      handler(newService) {
        this.form.status = newService.status;
        this.form.description = newService.description;
        this.form.ticket_person = newService.ticket_person;
        this.form.ticket_phone = newService.ticket_phone;
        this.form.ticket_email = newService.ticket_email;
        this.form.created_at = newService.created_at;
        this.form.ended_at = newService.ended_at;
      },
      deep: true
    },
    adres: {
      handler(newAdres) {
        this.form.delivery_street = newAdres.delivery_street;
        this.form.delivery_zip_code = newAdres.delivery_zip_code;
        this.form.delivery_city = newAdres.delivery_city;
        this.form.delivery_apartment = newAdres.delivery_apartment;
      },
      deep: true
    },
    warranty: {
      handler(newWarranty) {
        if (!this.form.warranty_length) {
          this.form.warranty_length = newWarranty.warranty_length;
        }
        if (!this.form.warranty_end) {
          this.form.warranty_end = newWarranty.warranty_end;
        }
      },
      deep: true
    },
    warranty_save: {
      handler(newWarrantySave) {
        this.form.warranty_length = newWarrantySave.warranty_length || this.warranty?.warranty_length || '';
        this.form.warranty_end = newWarrantySave.warranty_end || this.warranty?.warranty_to_date || '';
      },
      deep: true
    }
  },
  computed: {
    computedWarrantyLength() {
      return this.warranty_save?.warranty_length || this.warranty?.warranty_length || '';
    },
    computedWarrantyEndDate() {
      return this.warranty_save?.warranty_end || this.warranty?.warranty_to_date || '';
    },

    warrantyStatusText() {
      if (!this.computedWarrantyEndDate) {
        return "B/D";
      }
      const endDate = new Date(this.computedWarrantyEndDate);
      const today = new Date();
      return endDate >= today ? "Aktywna" : "Nieaktywna";
    },
    warrantyStatusClass() {
      if (!this.computedWarrantyEndDate) {
        return "btn-warning";
      }
      const endDate = new Date(this.computedWarrantyEndDate);
      const today = new Date();
      return endDate >= today ? "btn-success" : "btn-danger";
    }


  },
  mounted() {
    this.form = {
      status: this.service.status || "NOWE",
      service_category_ids: this.selectedCategories || [],
      description: this.service.description || '',
      delivery_street: this.adres.delivery_street || '',
      delivery_zip_code: this.adres.delivery_zip_code || '',
      delivery_city: this.adres.delivery_city || '',
      delivery_apartment: this.adres.delivery_apartment || '',
      ticket_person: this.service.ticket_person || '',
      ticket_phone: this.service.ticket_phone || '',
      ticket_email: this.service.ticket_email || '',
      created_at: this.service.created_at || '',
      ended_at: this.service.ended_at || '',
      warranty_length: this.warranty_save?.warranty_length || this.warranty?.warranty_length || '',
      warranty_end: this.warranty_save?.warranty_end || this.warranty?.warranty_to_date || ''
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    isRouteActive(routeName) {
      return route().current() === routeName;
    },

    route,
    isRouteActive(routeName) {
      return route().current() === routeName;
    },

    updateWarrantyLength(event) {
      this.form.warranty_length = event.target.value;
    },
    updateWarantyEndDate(event) {
      this.form.warranty_end = event.target.value;
    },

    formatDate(dateString) {
      if (!dateString) return '';
      let localDate = new Date(dateString);
      const timezoneOffset = localDate.getTimezoneOffset();
      localDate.setMinutes(localDate.getMinutes() - timezoneOffset);
      return localDate.toISOString().split('T')[0];
    },
    parseDateForSaving(dateString) {
      if (!dateString) return null;
      let localDate = new Date(dateString);
      localDate.setHours(12, 0, 0, 0);
      return localDate.toISOString();
    },
  
    updateDate(event) {
      this.form.created_at = event.target.value; 
    },

    updateEndDate(event) {
      this.form.ended_at = this.parseDateForSaving(event.target.value);
    },
    changeServiceCategories(selectedCategories) {
      this.form.service_category_ids = selectedCategories;
    },
    getTodayDate() {
      const today = new Date();
      return today.toISOString().split("T")[0]; 
    },

    changeServiceHideOnList() {
      this.hideOnListForm.hide_on_list = event.target.checked;
      this.hideOnListServiceHasChanged = true;
    },

    changeServiceArchived() {
      this.archiveOnListForm.archived = event.target.checked;
      this.archivedHasChanged = true;
    },

    submitHideOnList() {
      axios.post(route('service.updateHideOnList', {service: this.service.id}), {
        hide_on_list: this.hideOnListForm.hide_on_list
      })
          .then(() => {
            this.hideOnListServiceHasChanged = false;
            this.showToast('success', 'Sukces', 'Status ukrycia na liście został zaktualizowany.');
          })
          .catch(error => {
            console.error(error);
            this.showToast('error', 'Błąd', 'Nie udało się zapisać zmian.');
          });
    },

    submitArchived() {
      axios.post(route('service.updateArchived', {service: this.service.id}), {
        archived: this.archiveOnListForm.archived
      })
          .then(() => {
            this.archivedHasChanged = false;
            this.showToast('success', 'Sukces', 'Status archiwizacji został zaktualizowany.');
          })
          .catch(error => {
            console.error(error);
            this.showToast('error', 'Błąd', 'Nie udało się zapisać zmian.');
          });
    },


    async submitForm() {
      const self = this;
      this.form.errors = {};

      Object.keys(this.form).forEach(key => {
        if (this.form[key] === null) {
          this.form[key] = "";
        }
      });

      if (Object.keys(this.form.errors).length > 0) {
        return;
      }

      Toast.fire({
        toast: false,
        icon: 'info',
        title: 'Aktualizacja zgłoszenia',
        html: '<strong>Czy na pewno chcesz zapisać zmiany?</strong><br>Zmiany zostaną zapisane w systemie.',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Tak, zapisz',
        denyButtonText: 'Anuluj',
        position: 'center',
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          let formData = new FormData();

          Object.keys(this.form).forEach((key) => {
            if (key === "service_category_ids" && Array.isArray(this.form[key])) {
              this.form[key].forEach((id, index) => {
                formData.append(`service_category_ids[${index}]`, id);
              });
            } else if (key === "created_at") {
              formData.append(key, this.parseDateForSaving(this.form[key]));
            } else if (key === "ended_at") {
              formData.append(key, this.parseDateForSaving(this.form[key]));
            } else if (key === "warranty_end") {
              formData.append(key, this.parseDateForSaving(this.form[key]));
            } else {
              formData.append(key, this.form[key]);
            }
          });

          try {
            await router.post(route('service.update', {service: this.service.id}), formData, {
              preserveScroll: true,
              preserveState: true,
              onSuccess: () => {
                Toast.fire({
                  icon: 'success',
                  title: 'Zapisano zmiany',
                  html: '<strong>Zgłoszenie zostało pomyślnie zaktualizowane.</strong>',
                  timer: 3000,
                  timerProgressBar: true,
                });
              },
            });
          } catch (error) {
            console.error("Błąd zapisu:", error);
            Toast.fire({
              icon: 'error',
              title: 'Błąd zapisu',
              html: '<strong>Nie udało się zapisać zmian.</strong><br>Spróbuj ponownie później.',
            });
          }

          this.isLoading = false;
        }
      });
    },

    deleteService(event) {
      const self = this;
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie zgłoszenia',
        html: '<strong>Czy na pewno chcesz usunąć to zgłoszenie?</strong><br>Tej operacji nie można cofnąć!',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń',
        denyButtonText: 'Anuluj',
        position: 'center',
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(route('service.destroy', this.service.id), {
            headers: {
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
          }).then(response => {
            Toast.fire({
              icon: 'success',
              title: 'Zgłoszenie usunięte',
              html: '<strong>Zgłoszenie zostało pomyślnie usunięte.</strong><br>Za chwilę nastąpi przekierowanie...',
              timer: 3000,
              timerProgressBar: true,
            });
            setTimeout(() => {
              self.$inertia.visit(route('service.index'));
            }, 3000);
          }).catch(error => {
            console.error('Błąd usuwania:', error);
            Toast.fire({
              icon: 'error',
              title: 'Błąd usuwania',
              html: '<strong>Nie udało się usunąć zgłoszenia.</strong><br>Spróbuj ponownie później.',
            });
          });
        }
      });
    },
    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }


  },

};
const changeServiceCategories = (selectedCategories) => {
  form.service_category_ids = selectedCategories.map(category => category.id);
};

</script>


<style scoped>
.tooltip {
  opacity: 1 !important;
}
</style>
